// frontend/src/utils/emailTypoHelper.js

const DOMAIN_TYPOS = {
  // Gmail typos
  "gamil.com": "gmail.com",
  "gmal.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gmaill.com": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.co": "gmail.com",
  "gamil.con": "gmail.com",
  "gmal.con": "gmail.com",
  "gmail.comm": "gmail.com",
  "gmail.coom": "gmail.com",
  "gmaild.com": "gmail.com",
  "gmaio.com": "gmail.com",
  "gmail.cpm": "gmail.com",
  "gmeil.com": "gmail.com",

  // Yahoo typos
  "yaho.com": "yahoo.com",
  "yahooo.com": "yahoo.com",
  "yahoo.con": "yahoo.com",
  "ymail.con": "ymail.com",

  // Hotmail / Outlook typos
  "hotmial.com": "hotmail.com",
  "hotmaill.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "outlok.com": "outlook.com",
  "outlook.con": "outlook.com",
};

/**
 * Checks if an email has a known domain typo or invalid TLD like .con
 * Returns corrected suggestion string or null if clean.
 */
export const suggestEmailCorrection = (email) => {
  if (!email || typeof email !== "string") return null;
  const trimmed = email.trim().toLowerCase();
  const atIndex = trimmed.lastIndexOf("@");
  if (atIndex === -1) return null;

  const user = trimmed.slice(0, atIndex);
  const domain = trimmed.slice(atIndex + 1);

  if (!user || !domain) return null;

  // Direct match in typo dictionary
  if (DOMAIN_TYPOS[domain]) {
    return `${user}@${DOMAIN_TYPOS[domain]}`;
  }

  // Common TLD replacement for .con / .coom / .comm / .cpm
  if (domain.endsWith(".con")) {
    return `${user}@${domain.replace(/\.con$/, ".com")}`;
  }
  if (domain.endsWith(".coom")) {
    return `${user}@${domain.replace(/\.coom$/, ".com")}`;
  }
  if (domain.endsWith(".comm")) {
    return `${user}@${domain.replace(/\.comm$/, ".com")}`;
  }
  if (domain.endsWith(".cpm")) {
    return `${user}@${domain.replace(/\.cpm$/, ".com")}`;
  }

  return null;
};
